// A catalog price rollout (marketplace approval / MP price save) can now skip
// customer subscriptions whose price is PINNED (locked to a custom amount).
// The backend reports these under stripe_sync.skippedPinned. The shape may be
// an array of subs, an array plus a count, or an object { count, subs }, so
// normalise defensively here and return a single warning string (or null).
export const pinnedSkipMessage = (sync) => {
  if (!sync) return null;
  const sp = sync.skippedPinned;

  const arr = Array.isArray(sp)
    ? sp
    : Array.isArray(sp?.subs)
      ? sp.subs
      : Array.isArray(sp?.items)
        ? sp.items
        : [];

  const count =
    typeof sync.skippedPinnedCount === "number"
      ? sync.skippedPinnedCount
      : typeof sp?.count === "number"
        ? sp.count
        : typeof sp === "number"
          ? sp
          : arr.length;

  if (!count || count <= 0) return null;

  const ids = arr
    .map((s) =>
      typeof s === "object" && s !== null
        ? (s.id ??
          s.subscription_id ??
          s.purchasesubscription_id ??
          s.sub_id)
        : s,
    )
    .filter((v) => v !== undefined && v !== null);

  const one = count === 1;
  return (
    `${count} customer subscription${one ? "" : "s"} ${one ? "has a" : "have"} pinned custom ` +
    `price${one ? "" : "s"} and ${one ? "was" : "were"} NOT changed by this update — ` +
    `review ${one ? "it" : "them"} individually if needed.` +
    (ids.length ? ` (Sub ID${ids.length === 1 ? "" : "s"}: ${ids.join(", ")})` : "")
  );
};
